import { Reducer } from "./Reducer";

export class EventStateManager<State, Event> {
  public constructor(
    public state: State,
    public readonly reducer: Reducer<State, Event>,
    public onChange?: (state: State, event: Event) => void,
    public readonly undoReducer?: Reducer<State, Event>,
    public onBeforeChange?: (state: State, event: Event) => void
  ) {}

  receive(event: Event) {
    this.onBeforeChange?.(this.state, event);
    this.state = this.reducer(this.state, event);
    this.onChange?.(this.state, event);
  }
  undo(event: Event) {
    const { undoReducer } = this;
    if (!undoReducer) {
      throw new Error("cannot undo: no undoReducer");
    }
    this.state = undoReducer(this.state, event);
    this.onChange?.(this.state, event);
  }

  receiveAll(events: Event[]) {
    events.forEach((event) => this.receive(event));
  }
}
